import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputInternalUserSelectModule } from '../../../../components/input/input-internal-user-select';
import { TicketMessageComponent } from './ticket-message.component';
import { AudioRecorderModule } from '../../../../components/audio-recorder/audio-recorder.module';
import { VoiceRecordingModule } from '../../../../components/voice-recording/index';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AudioRecorderModule,
    VoiceRecordingModule,
    InputInternalUserSelectModule,
  ],
  declarations: [
    TicketMessageComponent,
  ],
  exports: [
    TicketMessageComponent,
  ],
})
export class TicketMessageModule {}
